import { Controller } from "@hotwired/stimulus"

// Add to Cart in Virtual Meeting (TMS-1677): the buyer stays on the page. The form posts in the
// background, the topbar cart count goes up, and the button becomes an "In Cart" link to the
// cart. Without JavaScript the form posts normally and the page reloads with the same result.
// A session that ran out answers 401 with the sign-in page; the server keeps the offering for
// when the buyer comes back.
export default class extends Controller {
  static targets = ["button", "error"]
  static values = { inCartClass: String, cartUrl: String }

  async add(event) {
    event.preventDefault()
    if (this.buttonTarget.disabled) return

    this.buttonTarget.disabled = true
    const response = await fetch(this.element.action, {
      method: "POST",
      body: new FormData(this.element),
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    })
    const body = await response.json().catch(() => ({}))

    if (response.status === 401 && body.sign_in_url) {
      window.location.assign(body.sign_in_url)
    } else if (response.ok && Number.isInteger(body.count)) {
      this.updateCount(body.count)
      this.showInCart(body.cart_url)
    } else {
      this.buttonTarget.disabled = false
      this.showError(body.error || "This offering couldn't be added. Please try again.")
    }
  }

  updateCount(count) {
    document.querySelectorAll("[data-vm-cart-count]").forEach((badge) => {
      badge.textContent = count
      badge.toggleAttribute("hidden", count === 0)
    })
    document.querySelectorAll("[data-vm-cart-count-label]").forEach((label) => {
      label.textContent = `${count} ${count === 1 ? "item" : "items"}`
    })
  }

  showInCart(cartUrl) {
    const link = document.createElement("a")
    link.href = cartUrl || this.cartUrlValue
    link.className = this.inCartClassValue
    link.innerHTML = '<i class="ph ph-check" aria-hidden="true"></i> In Cart'
    this.element.replaceWith(link)
    link.focus()
  }

  showError(message) {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = message
    this.errorTarget.hidden = false
  }
}
